import { COLOR_OPTIONS } from 'config/style';
import type { Feature, Geometry } from 'geojson';
import type { RegionalOverviewLevel } from '../regional-overview.models';

export enum RegionalRiskLevelLegend {
  'NO_RISK' = 'no_risk',
  'LOW_RISK' = 'low_risk',
  'MEDIUM_RISK' = 'medium_risk',
  'HIGH_RISK' = 'high_risk'
}

export const RegionalRiskLevelColor = {
  NO_RISK: COLOR_OPTIONS.NEUTRAL_30,
  LOW_RISK: COLOR_OPTIONS.GREEN_50,
  MEDIUM_RISK: COLOR_OPTIONS.ORANGE_30,
  HIGH_RISK: COLOR_OPTIONS.RED_60,
  MISSING_CONFIG: COLOR_OPTIONS.NEUTRAL_50
} as const;

export interface IDataBBCH {
  prevBBCH: string;
  percentage: string;
  textBBCH: string;
}
export interface IDataImpactedFields {
  name: RegionalRiskLevelLegend;
  value: string;
}

export interface IDataDetailedStatistics {
  risksStatistics: IDataImpactedFields[];
  bbchStatistics: IDataBBCH[];
}

export const regionalRiskLevels: RegionalOverviewLevel[] = [
  {
    type: 'no_risk',
    value: '3',
    level: 25,
    legend_color: RegionalRiskLevelColor.NO_RISK,
    text_color: '#363948'
  },
  {
    type: 'low_risk',
    value: '0',
    level: 25,
    legend_color: RegionalRiskLevelColor.LOW_RISK,
    text_color: '#363948'
  },
  {
    type: 'medium_risk',
    value: '1',
    level: 25,
    legend_color: RegionalRiskLevelColor.MEDIUM_RISK,
    text_color: '#363948'
  },
  {
    type: 'high_risk',
    value: '2',
    level: 25,
    legend_color: RegionalRiskLevelColor.HIGH_RISK,
    text_color: '#363948'
  }
];

export interface MapPropertiesPointFeature {
  id: string;
  icon: string;
  propertyName: string;
  amountFields: number;
}

export interface IRegionalRiskFilteredResults<T> {
  diseases: string[];
  growthStages: string[];
  filtered: boolean;
  filteredFeatures: Feature<Geometry, T>[];
}
